module.exports = __webpack_public_path__ + "static/media/balloon4.266b7350.png";